export const articlesHeroSubtitle = 'Research & Publications';
export const articlesHeroTitle = '논문 및 연구자료';
export const articlesHeroDescription = '솔티드의 연구 성과와 학술 논문을 확인하세요';

export const articlesPageTitle = 'Research';
export const articlesLoginNotice = '논문을 다운로드 받고 싶으신 분은 로그인을 해주세요.';
export const articlesLoginButton = '간단 로그인';

// Categories
export const categoryAll = '전체';
export const categoryMotion = '동작분석';
export const categoryEMG = '표면근전도';
export const categoryGait = '보행분석';
export const categoryBalance = '균형분석';
export const categorySpine = '척추구조분석';
export const categoryStrength = '근력/감각측정';
export const categoryTherapy = '열/전기';
export const categorySwallowing = '연하장애';
export const categoryCognitive = '인지재활';
export const categoryRespiratory = '호흡재활';

// Search
export const searchTypeTitle = '제목';
export const searchTypeProduct = '제품명';
export const searchPlaceholder = '검색어를 입력하세요.';
export const searchButton = '검색';
export const resetButton = '초기화';

// Table
export const tableHeaderTitle = '제목';
export const tableHeaderDownload = 'DOWNLOAD';
export const noResults = '검색 결과가 없습니다.';
export const loading = '로딩 중...';

// Pagination
export const paginationFirst = '처음';
export const paginationPrev = '이전';
export const paginationNext = '다음';
export const paginationLast = '맨끝';

export default {
  articlesHeroSubtitle,
  articlesHeroTitle,
  articlesHeroDescription,
  articlesPageTitle,
  articlesLoginNotice,
  articlesLoginButton,
  categoryAll,
  categoryMotion,
  categoryEMG,
  categoryGait,
  categoryBalance,
  categorySpine,
  categoryStrength,
  categoryTherapy,
  categorySwallowing,
  categoryCognitive,
  categoryRespiratory,
  searchTypeTitle,
  searchTypeProduct,
  searchPlaceholder,
  searchButton,
  resetButton,
  tableHeaderTitle,
  tableHeaderDownload,
  noResults,
  loading,
  paginationFirst,
  paginationPrev,
  paginationNext,
  paginationLast
};
